module.exports = __webpack_public_path__ + "img/yaoshi-zhongji.08a86be5.png";